import React from 'react';
import ReactDOM from 'react-dom';
const Router       = require('autor');
const MenuDefault  = require('./menu-default.jsx');
const MenuDocument = require('./menu-document.jsx');
const MenuLibrary  = require('./menu-library.jsx');

class Menu extends React.Component {
  constructor() {
    super();
    this.state = {mobileMenuOpen: false};
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.routerLocation !== this.props.routerLocation) return true;
    if (nextState.mobileMenuOpen !== this.state.mobileMenuOpen) return true;
    return false;
  }

  toggleMobileMenu() {
    if (document.body.classList.contains('menu-open')) document.body.classList.remove('menu-open');
    else document.body.classList.add('menu-open');
    // this.setState({mobileMenuOpen: this.state.mobileMenuOpen ? false: true});
  }

  render() {
    return (
      <div>
        <div id="menu-button" onClick={this.toggleMobileMenu.bind(this)}>
          <svg className="menu-button__closed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 50" style={{width: '22px'}}>
            <path d="M 0,0 L 55,0 L 55,8 L 0,8 Z" fill="#000000"/>
            <path d="M 0,21 L 55,21 L 55,29 L 0,29 Z" fill="#000000"/>
            <path d="M 0,42 L 55,42 L 55,50 L 0,50 Z" fill="#000000"/>
          </svg>
          <svg className="menu-button__open" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 50" style={{width: '22px'}}>
            <path d="M 6,0 L 55,44 L 49,50 L 0,6 Z" fill="#000000"/>
            <path d="M 49,0 L 55,6 L 6,50 L 0,44 Z" fill="#000000"/>
          </svg>
        </div>

        <div id="menu-header"><h1><a className="inner-page-link" href="/">All Conference</a></h1></div>
        <div id="menu-main" className={this.state.mobileMenuOpen ? 'menu-open container': 'container'}>
          <MenuDefault  routerLocation={this.props.routerLocation} toggleMobileMenu={this.toggleMobileMenu.bind(this)}></MenuDefault>
          <MenuDocument routerLocation={this.props.routerLocation} toggleMobileMenu={this.toggleMobileMenu.bind(this)}></MenuDocument>
          <MenuLibrary  routerLocation={this.props.routerLocation}></MenuLibrary>
        </div>
      </div>
    )
  }
}

Router.routeDidBootstrap((route) => {
  ReactDOM.render(
    <Menu routerLocation={Router.location}></Menu>,
    document.getElementById('menu')
  );
});

module.exports = Menu;



// WEBPACK FOOTER //
// ./src/js/menu.jsx